import { render, staticRenderFns } from "./ChurchsInputComponent.vue?vue&type=template&id=78324da0&"
import script from "./ChurchsInputComponent.vue?vue&type=script&lang=js&"
export * from "./ChurchsInputComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChurchsInputComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports